import { navigate } from 'gatsby'

import { isInternalLink } from './isInternalLink'
import { HAS_WINDOW } from '../../local_modules/constants'

export const navigateToLink = (link: string) => {
  if (!HAS_WINDOW) {
    return
  }

  if (isInternalLink(link)) {
    navigate(link)

    return
  }

  window.location.href = link
}
